var map = {
	"./home/classes/1-to-al.png": "5cda",
	"./home/classes/job-seekers.png": "595a",
	"./home/classes/language-classes.png": "9380",
	"./home/classes/professionals.png": "0316",
	"./logo-akurata.lk.svg": "c630",
	"./menu/kapila-siriwardhana-leccturing-01-small.jpg": "b88d",
	"./menu/kapila-siriwardhana-leccturing-02-small.jpg": "9b8c",
	"./menu/kapila-siriwardhana-leccturing-03-small.jpg": "ea95",
	"./menu/kapila-siriwardhana-leccturing-04-small.jpg": "d41c",
	"./placeholders/placeholder-image.png": "afc6",
	"./placeholders/profile-image-placeholder.png": "7449",
	"./placeholders/upload-video.png": "158a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";